// extracted by mini-css-extract-plugin
export default {"background":"background--WBQ9j"};